<script setup>
import { computed, inject } from 'vue';
import { calculateXPCostForCharacter } from '@/utils/xp-math';

const character = inject('printCharacter');
const system = inject('printSystem');

const xpSpent = computed(() => {
  let total = 0;
  if (!character.loading && !system.loading) {
    total = calculateXPCostForCharacter(character, system);
  }
  return total;
});
</script>

<template>
  <div style="height: 2in; border-bottom: 1px solid #888;">
    <div class="w3-row">
      <div class="w3-threequarter">
        <div class="w3-row">
          <div class="w3-col no-overflow quester" style="width: 5.75in;">
            <span class="label subdued inline-label">Character:</span> {{ character.characterName }}
          </div>
        </div>
        <div class="w3-row">
          <div class="w3-col no-overflow character" style="width: 5.75in;">
            <span class="label subdued inline-label">Player:</span>{{ character.quester.fullName }}
          </div>
        </div>
      </div>


      <div class="w3-quarter">
        <div class="w3-row">
          <div class="w3-col xp-box" style="margin-right: 20px;">
            <span class="xp-label">
              XP Spent
            </span>
            <div class="xp-value">
              {{ xpSpent }}
            </div>
          </div>
          <div class="w3-col xp-box">
            <span class="xp-label">
              XP Avail
            </span>
            <div class="xp-value">
              {{ character.xpAvailable }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="w3-row" style="height: 0.62in;">
      <div class="w3-col vertical-no-overflow-2" style="white-space: normal; width: 8in;max-height: 0.6in;">
        <span class="description"><span class="label subdued inline-label-long">Description:</span> {{ character.description }}</span>
      </div>
    </div>
    <div class="w3-row" style="height: 0.62in;">
      <div class="w3-col vertical-no-overflow-2" style="width: 8in;max-height: 0.6in;">
        <span class="description"><span class="label subdued inline-label-long">Current Goal:</span>{{ character.customFields['current-goal'] }}</span>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
@import "@/views/character-view-printable/styles/layout.css";

.label {
  font-size: 0.15in;
}

.inline-label {
  width: 0.75in;
  display: inline-block;
}

.inline-label-long {
  width: 1in;
  display: inline-block;
}

.vertical-label {
  writing-mode: sideways-lr;
  text-orientation: mixed;
}

.subdued {
  color: #888;
}

.quester, .character {
  font-size: 0.25in;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.description {
  font-size: 0.20in;
}

.xp-box, .wallet-box {
  display: inline-block;
  white-space: nowrap;
  border: 1px solid black;
  border-radius: 3px;
  margin: 5px;
  height: 0.5in;
}

.xp-box {
  width: 0.75in;
}

.xp-label, .wallet-label {
  position: relative;
  top: -8px;
  left: 10px;
  padding: 1px 2px 1px 2px;
  background-color: white;
}

.xp-value, .wallet-value {
  width: 100%;
  text-align: left;
  font-weight: bold;
  font-size: 0.3in;
  vertical-align: top;
  margin-top: -15px;
  margin-left: 5px;
}

//.wallet-section {
//  float: left;
//}
.wallet-box {
  width: 1.25in;
}

.vertical-no-overflow-2 {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
</style>
